<template>
  <div>
    <div v-if="podcast">
      <div v-if="!podcast.itunes_detail" class="row">
        <div class="col-12">
          <div class="alert alert-outline-dark">
            <div class="alert-text">
              <p class="font-weight-bold">
                Your {{ getFeedLabel(true) }} does not have <a href="#feed_channel_portlet">Channel Information</a>. This must be populated in order to enable your {{ getFeedLabel(true) }} Website.
              </p>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!podcast.podcast_website.enabled">
        <loader v-if="website_loading" loading-text="Enabling Website..." />
        <div v-else>
          <div class="col-12 d-flex flex-column align-items-center">
            <label for="website-toggle" class="mb-3 font-bold text-lg">
              There is no Website currently configured for this {{ getFeedLabel(true) }}.
            </label>
            <button id="website-toggle"
                    type="button"
                    class="btn btn-ss-standout"
                    @click="togglePodcastWebsite">
              Enable Website
            </button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label for="name">Name Override</label>
              <input id="name"
                     v-model="podcast.podcast_website.name"
                     type="text"
                     class="form-control kt-input"
                     :placeholder="`Uses ${getFeedLabel(true)} 'name' by default`">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label for="description">Description Override</label>
              <tip-tap v-model="podcast.podcast_website.description"
                       input-id="description"
                       placeholder="" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-8">
            <div class="form-group">
              <label for="landing-episode">
                Landing Episode <i id="landing-episode-tooltip" class="la la-question-circle" />
                <b-tooltip target="landing-episode-tooltip" triggers="hover">
                  <div v-sanitise="tooltips.landing_episode" />
                </b-tooltip>
              </label>
              <multiselect v-model="podcast.podcast_website.landing_episode"
                           :options="published_episodes"
                           label="name"
                           track-by="uuid"
                           :loading="!episodes_loaded"
                           :disabled="!episodes_loaded" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-8 d-flex" style="gap: 0.5rem;">
            <a v-if="podcast.podcast_website.url"
               :href="podcast.podcast_website.url"
               class="btn btn-ss"
               target="_blank">
              View {{ getFeedLabel(true) }}
            </a>
            <a v-if="website_base_url"
               :href="website_base_url"
               class="btn btn-ss"
               target="_blank">
              View Homepage
            </a>
            <button type="button"
                    class="btn btn-ss-danger ml-auto mr-0"
                    :disabled="website_loading"
                    @click="confirmBeforeRemove">
              <b-spinner v-if="website_loading"
                         small
                         label="Removing Website..."
                         class="mr-2" />
              Remove {{ getFeedLabel(true) }}
            </button>
          </div>
        </div>
      </template>
    </div>

    <delete-confirm-modal title="Removal Warning"
                          width="600"
                          delete-button-text="Remove Podcast">
      <div class="font-normal px-3">
        Removing this {{ getFeedLabel(true) }} from your Website will make this {{ getFeedLabel(true) }} inaccessible via the Timbre {{ getFeedLabel(true) }} Website and erase any override fields you have set.
      </div>
    </delete-confirm-modal>
  </div>
</template>

<script>
import { mapState, mapWritableState, mapActions } from 'pinia';
import { usePodcastManageStore } from "VueStore/app/podcastManage";
import DeleteConfirmModal from "VueModals/DeleteConfirmModal";
import Loader from "VuePartials/Loader";
import TooltipsMixin from "VueMixins/TooltipsMixin";

export default {
  components: {
    DeleteConfirmModal,
    Loader,
  },
  mixins: [TooltipsMixin],
  data: () => ({
    website_base_url: null,
  }),
  computed: {
    ...mapWritableState(usePodcastManageStore, ['podcast']),
    ...mapWritableState(usePodcastManageStore, ['website_loading']),
    ...mapState(usePodcastManageStore, ['episodes']),
    published_episodes() {
      return this.episodes.filter(ep => ep.published);
    },
    episodes_loaded() {
      return this.published_episodes.length;
    },
  },
  mounted() {
    EventBus.$on('feed-updated', (payload) => {
      this.setPodcastData(payload);
    });

    this.website_base_url = window.user.customer.podcast_website_url;
  },
  methods: {
    ...mapActions(usePodcastManageStore, ['setPodcastData']),
    ...mapActions(usePodcastManageStore, ['togglePodcastWebsite']),
    async confirmBeforeRemove() {
      if (this.podcast.podcast_website.enabled) {
        const { data } = (await this.fireModal('delete-confirm'));

        if (data.confirm) {
          this.togglePodcastWebsite();
        } else {
          this.podcast.podcast_website.enabled = true;
        }
      } else {
        this.togglePodcastWebsite();
      }
    },
  },
};
</script>
